import { Injectable } from '@angular/core';
import { INeighborhoodType, NeighborhoodType } from '../models/neighborhood-type.model';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';
import { AwsService } from './aws.service';
import { IPresignResponse } from '../models/presign-response.model';

@Injectable({
  providedIn: 'root'
})
export class NeighborhoodTypeService {

  public loading: boolean = false;
  public neighborhoodTypes: NeighborhoodType[] = [];

  constructor(
    public authService: AuthService,
    public awsService: AwsService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) {

    this.getAll();

  }

  /*
   ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
   ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
   async create(
    neighBorhoodType: INeighborhoodType,
    file?: File
  ): Promise<boolean> {

    let flag = false;

    const urlApi = `${environment.urlApi}/neighborhood-types`;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Registrando tipo de colonia';

    try {

      const token = await this.authService.getToken();

      const body: any = { ...neighBorhoodType };
      if (file) {
        body.contentType = file.type;
      }

      const response = await new Promise<ServerResponse<{presignFile: IPresignResponse}>>(
        (resolve, reject) => {
          this.http.post<IServerResponse<{presignFile: IPresignResponse}>>(
            urlApi,
            JSON.stringify(body),
            {
              headers: {
                "content-type": "application/json",
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{presignFile: IPresignResponse}>
              ) => resolve(
                new ServerResponse(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 201) {
        flag = true;

        if (file && response.data?.presignFile?.uploadUrl) {
          await this.awsService.uploadFile(
            response.data.presignFile.uploadUrl,
            file,
            file.type,
            file.name
          );
        }

        this.toastService.show(
          {
            body: `${response.message}`,
            classname: 'bg-success text-white'
          }
        );

        this.getAll();
      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    return flag;

  }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete(
    neighBorhoodType: NeighborhoodType
  ): Promise<boolean> {

    let flag = false;

    const urlApi = `${environment.urlApi}/neighborhood-types/${neighBorhoodType.neighborhoodTypeId}`;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Eliminando tipo de colonia';

    try {

      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse>(
        (resolve, reject) => {
          this.http.delete<IServerResponse>(
            urlApi,
            {
              headers: {
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse
              ) => resolve(
                new ServerResponse(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        flag = true;

        this.toastService.show(
          {
            body: `${response.message}`,
            classname: 'bg-success text-white'
          }
        );

        this.getAll();
      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }

    this.spinnerService.loading = false;
    this.spinnerService.message = '';
  
    return flag;

  }

  /*
   ██████╗ ███████╗████████╗ █████╗ ██╗     ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔══██╗██║     ██║
  ██║  ███╗█████╗     ██║   ███████║██║     ██║
  ██║   ██║██╔══╝     ██║   ██╔══██║██║     ██║
  ╚██████╔╝███████╗   ██║   ██║  ██║███████╗███████╗
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚══════╝

  */
  /**
   * FUNCTION getAll
   */
  async getAll() {

    this.loading = true;

    const urlApi = `${environment.urlApi}/neighborhood-types`;

    try {

      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse<{ neighborhoodTypes: INeighborhoodType[] }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ neighborhoodTypes: INeighborhoodType[] }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ neighborhoodTypes: INeighborhoodType[] }>
              ) => resolve(
                new ServerResponse<{ neighborhoodTypes: INeighborhoodType[] }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        this.neighborhoodTypes = response.data!.neighborhoodTypes.map(
          neighBorhoodType => new NeighborhoodType(neighBorhoodType)
        );
      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);
      
    }

    this.loading = false;

  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update(
    neighBorhoodType: INeighborhoodType,
    file?: File
  ): Promise<boolean> {

    let flag = false;

    const urlApi = `${environment.urlApi}/neighborhood-types/${neighBorhoodType.neighborhoodTypeId}`;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Actualizando tipo de colonia';

    try {

      const token = await this.authService.getToken();

      const body: any = { ...neighBorhoodType };
      if (file) {
        body.contentType = file.type;
      }

      const response = await new Promise<ServerResponse<{presignFile: IPresignResponse}>>(
        (resolve, reject) => {
          this.http.put<IServerResponse<{presignFile: IPresignResponse}>>(
            urlApi,
            JSON.stringify(body),
            {
              headers: {
                "content-type": "application/json",
                'Authorization': token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{presignFile: IPresignResponse}>
              ) => resolve(
                new ServerResponse(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
                this.toastService.show(
                  {
                    header: 'Error de servidor',
                    body: `${error}`,
                    classname: 'bg-danger text-white'
                  }
                );
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        flag = true;

        if (file && response.data?.presignFile?.uploadUrl) {
          await this.awsService.uploadFile(
            response.data.presignFile.uploadUrl,
            file,
            file.type,
            file.name
          );
        }

        this.toastService.show(
          {
            body: `${response.message}`,
            classname: 'bg-success text-white'
          }
        );

        this.getAll();
      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {
      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );
    }

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    return flag;

  }
}
